import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register the service worker early (independent of push) so the app shell is
// cached and the login / offline-alerts pages render when the server is down.
// Same script + scope as the push registration in pushNotifications.js, so this
// is idempotent and the two do not conflict. Secure-context only (https/localhost).
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' }).catch(() => {});
  });
}
